module.exports = __webpack_public_path__ + "static/media/contact-logo-hover.bf527fc0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/contact-logo-hover.svg
 ** module id = 1298
 ** module chunks = 0
 **/